import React from "react";
import { useTranslation } from "react-i18next";
import { MAX_BOOK_DESCRIPTION_WORDS_COUNT } from "shared/constants/misc";
import { CircleCounter, CircleColorType } from "./CircleCounter";

interface WordCounterProps {
  count: number;
  maxCount?: number;
  color?: CircleColorType;
}

export const WordCounter: React.FC<WordCounterProps> = ({
  count,
  maxCount = MAX_BOOK_DESCRIPTION_WORDS_COUNT,
  color = CircleColorType.Green,
}) => {
  const { t } = useTranslation(["components"]);

  const showTooltip = !!maxCount;
  const tooltipProps = showTooltip
    ? {
        tooltip: {
          title:
            count <= maxCount
              ? t("components:indicators.wordCounter.tooltip.ok.title")
              : t("components:indicators.wordCounter.tooltip.warning.title"),
          description: [
            count <= maxCount
              ? t(
                  "components:indicators.wordCounter.tooltip.ok.description.line1",
                )
              : t(
                  "components:indicators.wordCounter.tooltip.warning.description.line1",
                ),
            count <= maxCount
              ? t(
                  "components:indicators.wordCounter.tooltip.ok.description.line2",
                  { maxCount },
                )
              : t(
                  "components:indicators.wordCounter.tooltip.warning.description.line2",
                  { maxCount },
                ),
          ],
        },
      }
    : {};

  return (
    <CircleCounter
      value={count}
      maxValue={showTooltip ? maxCount : undefined}
      label={t("components:indicators.wordCounter.label")}
      color={color}
      showWarning={showTooltip}
      {...tooltipProps}
    />
  );
};
